import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { RequestService, HttpRequestType } from 'src/app/core/request.service';
import { DocumentStorage } from './files.models';
import { AlertService } from 'src/app/core/alert.service';
import { Constants } from 'src/app/app.constants';
import { tap, map, catchError } from 'rxjs/operators';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { DxoFullstackedsplineModule } from 'devextreme-angular/ui/nested';

@Injectable({
  providedIn: 'root'
})
export class FilesService extends BaseService {
  [x: string]: any;
  private url: string = `${Constants.contextPath}/document-storage`;

  constructor(protected requestService: RequestService, private alertService: AlertService, private httpClient: HttpClient) {
    super(requestService);
  }

  public getUploadLink(file: DocumentStorage, onSuccess: Function, onFail: Function = null) {
    this.requestService.createRequest(HttpRequestType.Put, `${this.url}/file/request-upload`, file, null, (response) => {
      onSuccess(response);
    }, (error) => {
      if (onFail != null)
        onFail(error);
      else
        this.alertService.error(error, true);
    });
  }

  public getUploadLinks(files: DocumentStorage, onSuccess: Function, onFail: Function = null) {
    this.requestService.createRequest(HttpRequestType.Put, `${this.url}/files/request-upload`, files, null, (response) => {
      onSuccess(response);
    }, (error) => {
      if (onFail != null)
        onFail(error);
      else
        this.alertService.error(error, true);
    });
  }

  public deleteFile(file: DocumentStorage, onSuccess: Function, onFail: Function = null) {
    this.requestService.createRequest(HttpRequestType.Delete, `${this.url}/file/delete`, file, null, () => {
      onSuccess();
    }, (error) => {
      if (onFail != null)
        onFail(error);
      else
        this.alertService.error(error, true);
    });
  }

  public deleteFiles(files: DocumentStorage, onSuccess: Function, onFail: Function = null) {
    this.requestService.createRequest(HttpRequestType.Delete, `${this.url}/files/delete-multiple`, files, null, () => {
      onSuccess();
    }, (error) => {
      if (onFail != null)
        onFail(error);
      else
        this.alertService.error(error, true);
    });
  }

  public fileUploadFunction(url: string): (file: File, progressCallback: Function) => any {
    return (file: File, progressCallback: Function): any => {
      return this.httpClient.put(
        url,
        file,
        {
          reportProgress: true,
          observe: 'events'
        }
      ).pipe(

        tap((event: HttpEvent<any>) => {

          if (event.type === HttpEventType.UploadProgress)
            progressCallback(event.loaded);
        })
      ).toPromise();
    };
  }
  
  public getImageFromPath(image: string) {
    let parts = image.split('/');
    return {
      comapnyId: parts[1],
      type: parts[2].toUpperCase().replace(/-/g, '_'),
      code: parts[3],
      name: parts[4]
    };
  }
}

